const data = [
  {
    title: "Star Rating",
    shortDescription:
      "The feedback system you see on Amazon or Uber. Hover to preview a score, and click to 'lock' it in.",
    description:
      "This project teaches you how to handle two competing states at the same time: 'What I am hovering over' vs. 'What I actually clicked.' We create a loop of 5 stars. The logic is a simple comparison: If you hover over Star #3, the code asks every star: *'Is your number less than or equal to 3?'* If yes, it turns yellow. If no, it stays black. It's a great exercise in using conditional styling based on array indexes.",
  }
];
export default data;